/**
 * Teen Plot section only:
 * 1. Before/after image toggle
 * 2. Video testimonial Swiper
 *
 * Requires Swiper CDN in theme.liquid.
 */
(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-teen-plot-section]';
  var retries = 0;

  function initToggle(section) {
    var toggle = section.querySelector('[data-plot-toggle]');
    var button = section.querySelector('[data-plot-toggle-button]');
    if (!toggle || !button || toggle.getAttribute('data-toggle-ready') === 'true') return;

    function changeState() {
      var isAfter = toggle.classList.toggle('is-after');
      button.setAttribute('aria-pressed', String(isAfter));
      button.setAttribute('aria-label', isAfter ? 'Show before image' : 'Show after image');
    }

    button.addEventListener('click', function (event) {
      event.stopPropagation();
      changeState();
    });

    toggle.addEventListener('click', function (event) {
      if (event.target !== button && !button.contains(event.target)) {
        changeState();
      }
    });

    toggle.setAttribute('data-toggle-ready', 'true');
  }

  function pauseVideos(slider) {
    var videos = slider.querySelectorAll('video');
    Array.prototype.forEach.call(videos, function (video) {
      if (!video.paused) video.pause();
    });
  }

  function initVideoSlider(section) {
    var root = section.querySelector('[data-plot-video-slider]');
    var slider = section.querySelector('[data-plot-video-swiper]');
    if (!root || !slider || root.getAttribute('data-video-slider-ready') === 'true') return;
    if (typeof window.Swiper === 'undefined') return;

    if (slider.swiper && !slider.swiper.destroyed) {
      slider.swiper.destroy(true, true);
    }

    new window.Swiper(slider, {
      direction: 'horizontal',
      effect: 'slide',
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 20,
      speed: 500,
      loop: false,
      rewind: true,
      autoHeight: true,
      watchOverflow: true,
      grabCursor: true,
      simulateTouch: true,
      allowTouchMove: true,
      navigation: {
        nextEl: root.querySelector('[data-plot-video-next]'),
        prevEl: root.querySelector('[data-plot-video-prev]'),
      },
      pagination: {
        el: root.querySelector('[data-plot-video-pagination]'),
        clickable: true,
      },
      on: {
        slideChange: function () {
          pauseVideos(slider);
        },
      },
    });

    root.setAttribute('data-video-slider-ready', 'true');
  }

  function initSection(section) {
    if (!section) return;
    initToggle(section);
    initVideoSlider(section);
  }

  function initAll(scope) {
    var parent = scope && scope.querySelectorAll ? scope : document;
    var sections = parent.querySelectorAll(SECTION_SELECTOR);

    if (scope && scope.matches && scope.matches(SECTION_SELECTOR)) {
      initSection(scope);
    }

    Array.prototype.forEach.call(sections, initSection);
  }

  function boot() {
    initAll(document);

    if (typeof window.Swiper === 'undefined' && retries < 60) {
      retries += 1;
      window.setTimeout(boot, 50);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target) return;

    var sections = target.querySelectorAll ? target.querySelectorAll(SECTION_SELECTOR) : [];
    Array.prototype.forEach.call(sections, function (section) {
      var root = section.querySelector('[data-plot-video-slider]');
      if (root) root.removeAttribute('data-video-slider-ready');
      var toggle = section.querySelector('[data-plot-toggle]');
      if (toggle) toggle.removeAttribute('data-toggle-ready');
    });

    initAll(target);
  });
})();
